import React from 'react';
import clsx from 'clsx';
import { Avatar } from '@components/basics/Images/Avatar';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { VerifiedTooltip } from '@components/main-components/tooltip/VerifiedTooltip';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment, SearchResultArtistFragmentDoc } from '@graphql/reactQuery';
import { webappUriPath } from '@utils/url';

export function SearchArtistRow({ data }: { data: FragmentType<SearchResultArtistFragmentDoc> }) {
  const { name, webappUri, user } = getFragment(SearchResultArtistFragmentDoc, data);

  const { avatar, publicAddress } = user;

  return (
    <AccessibleLink
      className="flex h-12 w-full items-center gap-3 rounded-md pr-3 hover:bg-neutral100 md:hidden"
      pathnameUri={webappUriPath(webappUri)}
    >
      <div
        className={clsx(
          'relative h-12 max-h-[3rem] w-12 max-w-[3rem] overflow-hidden',
          '[-webkit-transform]:[translateZ(0)] flex-shrink-0 rounded-md',
        )}
      >
        <Avatar
          size={48}
          src={avatar?.url}
          walletAddress={publicAddress}
          borderRadius="50%"
          webappUri={webappUri}
        />
      </div>
      <div className="flex flex-col gap-1 overflow-hidden">
        <div className="flex items-center gap-1">
          <span className="overflow-hidden text-ellipsis whitespace-nowrap font-title text-title-xs font-medium text-black">
            {name}
          </span>
          <VerifiedTooltip size={18} />
        </div>
        <span className="overflow-hidden text-ellipsis whitespace-nowrap font-base text-base-s font-normal text-base500">
          Artist
        </span>
      </div>
    </AccessibleLink>
  );
}
